export default __webpack_public_path__ + "static/media/arrow.a857c5d3.svg";